import { action, atom, withInit } from '@reatom/framework'

import { Data } from '@blade/std-lib'

import type { PairModel } from '@root/entities/pair'
import type { PremiumId, PremiumMetaModel } from '@root/entities/premium'
import type { ArchivedPremium } from '@root/entities/premium/model/premium-meta'

export class CurrentPremiumBannerView extends Data.TaggedClass(
  'CurrentPremiumBannerView',
)<{
  currentPremium: PremiumMetaModel
  pair: PairModel
}> {}

export class ArchivedPremiumBannerView extends Data.TaggedClass(
  'ArchivedPremiumBanner',
)<{
  archivedPremium: ArchivedPremium
  pair: PairModel
  withResetButton: boolean
}> {}

type PremiumBannerView = CurrentPremiumBannerView | ArchivedPremiumBannerView

export const currencyBannerViewModel = (args: { pair: PairModel }) => {
  const { pair } = args
  const currentPremiumBannerView = new CurrentPremiumBannerView({
    pair,
    currentPremium: pair.premiumInfo,
  })

  const viewAtom = atom<PremiumBannerView | undefined>(
    undefined,
    'viewAtom',
  ).pipe(
    withInit((ctx) => {
      const premium = ctx.get(pair.premiumInfo.premium)
      if (premium) {
        return new CurrentPremiumBannerView({
          pair,
          currentPremium: pair.premiumInfo,
        })
      } else {
        const [lastArchivedPremium] = ctx.get(pair.premiumInfo.archivedPremiums)

        if (lastArchivedPremium) {
          return new ArchivedPremiumBannerView({
            pair,
            archivedPremium: lastArchivedPremium,
            withResetButton: false,
          })
        }
      }
    }),
  )

  const setArchivedPremiumBannerViewAction = action(
    (ctx, premiumId: PremiumId) => {
      const archivedPremium = ctx
        .get(pair.premiumInfo.archivedPremiums)
        .find((premium) => premium.premiumId === premiumId)

      if (archivedPremium) {
        const premium = ctx.get(pair.premiumInfo.premium)
        viewAtom(
          ctx,
          new ArchivedPremiumBannerView({
            pair,
            archivedPremium,
            withResetButton: premium,
          }),
        )
      } else {
        viewAtom(ctx, currentPremiumBannerView)
      }
    },
    'setArchivedPremiumBannerViewAction',
  )

  const resetPremiumBannerViewAction = action((ctx) => {
    const premium = ctx.get(pair.premiumInfo.premium)

    if (!premium) {
      return
    }
    viewAtom(ctx, currentPremiumBannerView)
  }, 'resetPremiumBannerViewAction')

  return {
    viewAtom,
    setArchivedPremiumBannerViewAction,
    resetPremiumBannerViewAction,
  }
}

export interface CurrencyBannerViewModel
  extends ReturnType<typeof currencyBannerViewModel> {}
